// extracted by mini-css-extract-plugin
export default {"external":"a8N5Ob","tag":"b8N5Ob","text":"c8N5Ob","block":"d8N5Ob"};